import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

function useChapterActionIdMatch(stringToMatch) {
  const [isMatch, setIsMatch] = useState(false);

  const menuStructByUserId = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.menuStructByUserId;
  });
  useEffect(() => {
    if (menuStructByUserId && Array.isArray(menuStructByUserId)) {
      const matchingObject = menuStructByUserId.find(
        (item) => item.chapterActionId === stringToMatch,
      );

      if (matchingObject) {
        setIsMatch(true);
      } else {
        setIsMatch(false);
      }
    } else {
      setIsMatch(false);
    }
  }, [stringToMatch, menuStructByUserId]);

  return isMatch;
}

export default useChapterActionIdMatch;
